import { SCHEMA } from './../constants';

const isSerializedState = (state) =>
    state && typeof state === 'object' && Array.isArray(state[SCHEMA.UNITY]);

export default isSerializedState;
